import React, { useMemo } from "react";
import {
    Navigate,
    NavigateAction,
    TitleOptions,
    WeekProps,
} from "react-big-calendar";
// @ts-ignore
import TimeGrid from "react-big-calendar/lib/TimeGrid";

import PropTypes from "prop-types";

import { store } from "../../../..";
import { selectSelectedTournament } from "../../../../features/tourneymgmt/tournamentManagementSlice";
import { useAppSelector } from "../../../../hooks/reduxHooks";

interface TournamentViewProps extends WeekProps {
    localizer: {
        endOf: (date: Date, unit: string) => Date;
        startOf: (date: Date, unit: string) => Date;
        lte: (date1: Date, date2: Date, unit: string) => boolean;
        add: (date: Date, amount: number, unit: string) => Date;
    };
    max?: Date;
    min?: Date;
    scrollToTime?: Date;
    [key: string]: any;
}

function TournamentView({
    date,
    localizer,
    max = localizer.endOf(new Date(), "day"),
    min = localizer.startOf(new Date(), "day"),
    scrollToTime = localizer.startOf(new Date(), "day"),
    ...props
}: TournamentViewProps) {
    const currRange = useMemo(
        () => TournamentView.range(date, { localizer }),
        [date, localizer],
    );
    const tournament = useAppSelector(selectSelectedTournament);

    return (
        <TimeGrid
            date={tournament?.startDate}
            localizer={localizer}
            max={max}
            min={min}
            range={currRange}
            scrollToTime={scrollToTime}
            // eslint-disable-next-line
            {...props}
        />
    );
}

TournamentView.propTypes = {
    date: PropTypes.instanceOf(Date).isRequired,
    localizer: PropTypes.object,
    max: PropTypes.instanceOf(Date),
    min: PropTypes.instanceOf(Date),
    scrollToTime: PropTypes.instanceOf(Date),
};

TournamentView.range = (date: Date, { localizer }: any) => {
    const tournament = selectSelectedTournament(store.getState());
    const start = tournament?.startDate ? new Date(tournament.startDate) : date;
    const end = tournament?.endDate ? new Date(tournament.endDate) : date;

    let current = start;
    const range = [];

    while (localizer.lte(current, end, "day")) {
        range.push(current);
        current = localizer.add(current, 1, "day");
    }

    return range;
};

// This has to stay here as it is a required prop, even though the navigation buttons are hidden in this view.
TournamentView.navigate = (date: Date, action: NavigateAction) => {
    switch (action) {
        case Navigate.PREVIOUS:
            return date;

        case Navigate.NEXT:
            return date;

        default:
            return date;
    }
};

TournamentView.title = (date: Date, { localizer }: TitleOptions) => {
    const [start, ...rest] = TournamentView.range(date, { localizer });
    return localizer.format({ start, end: rest.pop() }, "dayRangeHeaderFormat");
};

export default TournamentView;
